var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "h3",
      {
        staticClass: "g-facet-set__heading",
        on: {
          click: function ($event) {
            _vm.section.collapse = !_vm.section.collapse
          },
        },
      },
      [
        _c(
          "button",
          { staticClass: "g-facet-set__label g-button--no-styling" },
          [_vm._v("\n\t\t\t" + _vm._s(_vm.section.label) + "\n\t\t")]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "g-facet-set__list" },
      [
        _vm._l(
          _vm.visibleCategories.slice(0, _vm.section.overflow.limit),
          function (category) {
            return _c(
              "div",
              {
                key: category.id,
                staticClass: "g-facet-set__list-item g-form-checkbox",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "g-facet-set__list-item-link",
                    attrs: { href: category.uri },
                  },
                  [
                    _c("span", {
                      staticClass: "g-facet-set__list-item-name",
                      class: {
                        "g-facet-set__list-item-name--applied":
                          category.code === _vm.activeCategoryCode,
                      },
                      domProps: { innerHTML: _vm._s(category.name) },
                    }),
                  ]
                ),
              ]
            )
          }
        ),
        _vm._v(" "),
        _vm.visibleCategories.length > _vm.section.overflow.limit
          ? _c("div", { staticClass: "g-facet-view-more" }, [
              _c("input", {
                staticClass: "g-facet-view-more__checkbox u-hide-visually",
                attrs: {
                  id: "g-facet-view-more__" + _vm.section.label,
                  type: "checkbox",
                },
                on: { change: _vm.viewMoreChange },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "g-facet-view-more__label",
                  attrs: { for: "g-facet-view-more__" + _vm.section.label },
                },
                [_vm._v("View More")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "g-facet-view-more__content" },
                _vm._l(
                  _vm.visibleCategories.slice(
                    _vm.section.overflow.limit,
                    _vm.visibleCategories.length
                  ),
                  function (category) {
                    return _c(
                      "div",
                      {
                        key: category.id,
                        staticClass: "g-facet-set__list-item g-form-checkbox",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "g-facet-set__list-item-link",
                            attrs: { href: category.uri },
                          },
                          [
                            _c("span", {
                              staticClass: "g-facet-set__list-item-name",
                              class: {
                                "g-facet-set__list-item-name--applied":
                                  category.code === _vm.activeCategoryCode,
                              },
                              domProps: { innerHTML: _vm._s(category.name) },
                            }),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }